exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}body{height:100%;display:flex;flex-direction:column}.container{margin:40px}.header{height:70px;align-items:center;display:flex}.logo{width:160px;margin-left:40px}.description{padding-left:30px;font-size:20px;font-weight:600;color:#555}.description2{font-size:15px;font-weight:600;color:#555;padding-bottom:40px}.footer{margin-top:4em;background-color:#f1f2f6;height:6em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c409689a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 16
// module chunks = 0